import React, { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface LabelProps extends HTMLAttributes<HTMLDivElement> {}

export const Label = ({ children, className }: LabelProps) => {
  const _className = twMerge("px-2 py-1 rounded font-semibold bg-secondary text-sm text-white", className)

  return <span className={_className}>{children}</span>
}
